import React from 'react';
import ContactHeader from '../components/contact/ContactHeader';
import ContactForm from '../components/contact/ContactForm';

function Contact() {
  return (
    <>
    <ContactHeader />
    <ContactForm />
    </>
  );
}

export default Contact;